import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box, Typography,
} from "@mui/material";
import { Padding } from "@mui/icons-material";

const PinnedDialog = {
    '& .MuiDialog-paper': {
        maxWidth: '800px',
        borderRadius: '12px',
        position: 'relative',
        p: '24px 20px',
    },

}

const DialogTitles = {
    color: '#1A2025',
    fontSize: '18px',
    lineHeight: '140%',
    fontWeight: 600,
}

const RenameField = {
    '& .MuiInputBase-input': {
        background: '#F6F7F0',
        height: '56px',
        borderRadius: '4px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: '0 !important'
    }
}

const CancelBtn = {
  border: "1px solid #0066CC",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "140%",
  height: "44px",
  padding: "0 20px",
  borderRadius: "32px",
  color: "#0066CC",
  textTransform: "capitalize",
};

const SaveBtn = {
  border: "1px solid #0066CC",
  background: "#0066CC",
  color: "#fff",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "140%",
  height: "44px",
  padding: "0 20px",
  borderRadius: "32px",
  textTransform: "capitalize",
};

export default function RenameDialog({
    open,
    initialValue,
    onClose,
    onSave,
}) {
    const [value, setValue] = useState("");

    useEffect(() => {
        if (open) {
            setValue(initialValue || "");
        }
    }, [open, initialValue]);

    const handleSave = () => {
        onSave(value);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={PinnedDialog}>
            <DialogTitle sx={{ p: 0 }}>
                <Typography sx={DialogTitles}> Rename the Dashboard </Typography>
            </DialogTitle>

            <DialogContent sx={{ p: 0, mt: '24px' }}>
                <Box mt={1} sx={RenameField}>
                    <TextField
                        fullWidth
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        size="small"
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 0, mt: '24px' }}>
                <Button onClick={onClose} sx={CancelBtn}>Cancel</Button>
                <Button sx={SaveBtn} onClick={handleSave}>
                    Save Changes
                </Button>
            </DialogActions>
        </Dialog>
    );
}

